import { get } from 'lodash-es'

import appConfig from '@/websites/current/pages/layout/app-config.json'

export function getAppConfig(path: string, defaultValue: any) {
  return get(appConfig, path, defaultValue)
}
